// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
   apiKey: "AIzaSyBXmLTVcKkEz73zzt6u7970UUn3Fa43Z9s",
  authDomain: "deonyak-935f2.firebaseapp.com",
  projectId: "deonyak-935f2",
  storageBucket: "deonyak-935f2.firebasestorage.app",
  messagingSenderId: "650426527700",
  appId: "1:650426527700:web:59fe38710a11d16cf6b041",
  measurementId: "G-1KTSWS49YN"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
